import { Box } from '@chakra-ui/react';
import { Container, LoadingContainer } from '@melio/penny';
import { forwardRef } from '@melio/platform-utils';

type EmailPreviewerProps = {
  isLoading: boolean;
  previewContent?: string;
};

const formatContent = (previewContent: string) => previewContent.replace(/href=["'][^"']*["']/gi, '');

export const EmailPreviewer = forwardRef<EmailPreviewerProps>(({ previewContent, isLoading, ...props }, ref) => (
  <LoadingContainer isLoading={isLoading}>
    <Container
      border="regular"
      data-component={EmailPreviewer.displayName}
      data-testid="email-previewer-container"
      {...props}
      ref={ref}
    >
      <Box
        height={isLoading ? '50vh' : 'auto'}
        dangerouslySetInnerHTML={{ __html: previewContent ? formatContent(previewContent) : '' }}
      />
    </Container>
  </LoadingContainer>
));
EmailPreviewer.displayName = 'EmailPreviewer';
